import { createTheme } from "@material-ui/core";

import palette from "./palette";
import typography from "./typography";
import overrides from "./overrides";

const theme = createTheme({
  palette,
  typography,
  overrides,
  fontFamilyCenturyGothic: 'century_gothic, sans-serif',
  fontFamilyCenturyGothicBold: "century_gothic_bold, sans-serif",
  fontFamilyInter: 'inter, sans-serif',
  fontFamilyInterBold: 'inter-bold, sans-serif',
  fontFamilyProximaRegular: 'proxima_nova_rgregular, sans-serif',
  fontFamilyArial: 'arial, sans-serif',
  fontFamilyArialBold: 'arial-bold, sans-serif',

  zIndex: {
    appBar: 1100,
    drawer: 1100,
  },
});

export default theme;
